import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const FETCH_BOOKING_DETAILS = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'fetchBookingDetails',
    args: [
      { name: 'company_id', type: 'String', required: true },
      { name: 'booking_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'company_id', value: 'company_id' },
      { name: 'booking_id', value: 'booking_id' },
    ],
    fields: '{...FetchBookingDetailsResponseFields}',
    fragments: [Fragments.fetchBookingDetailsResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const FETCH_BOOKING_LIST = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'fetchBookingList',
    args: [
      { name: 'company_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'company_id', value: 'company_id' },
    ],
    fields: '{...FetchBookingListResponseFields}',
    fragments: [Fragments.fetchBookingListResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const FETCH_UNIT_BOOKING = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'fetchUnitBooking',
    args: [
      { name: 'company_id', type: 'String', required: true },
      { name: 'unit_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'company_id', value: 'company_id' },
      { name: 'unit_id', value: 'unit_id' },
    ],
    fields: '{...FetchUnitBookingResponseFields}',
    fragments: [Fragments.fetchUnitBookingResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const FETCH_BOOKING_HISTORY = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'fetchBookingHistory',
    args: [
      { name: 'company_id', type: 'String', required: true },
      { name: 'unit_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'company_id', value: 'company_id' },
      { name: 'unit_id', value: 'unit_id' },
    ],
    fields: '{...FetchBookingHistoryResponseFields}',
    fragments: [Fragments.fetchBookingHistoryResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
